import { LabelProps, LabelSize } from '../../../models/label'
// import './Label.scss'

const Label = (props: LabelProps) => {
    const labelClass = 'label'
    const size = props.size || LabelSize.DEFAULT
    const boldClass = props.size === LabelSize.DEFAULT ? 'semi-bold' : ''
    const miniClass = props.size === LabelSize.MICRO ? 'mini' : ''

    return (
        <label
            className={`${labelClass} ${miniClass} ${boldClass} ${labelClass}__type--${props.type} ${labelClass}__size--${size} spacing`}>
            {props.children}
        </label>
    )
}

export default Label
